import './css/fonts.css'
import './css/old.css'
import './css/main.scss';

import './libs/jquery.min.js';
import './libs/flickity.pkgd.min.js';
import './libs/modal.js';
import './libs/dropdown.js';
import './libs/tooltip.js';
import './libs/popover.js';
import './libs/affix.js';
import './libs/nouislider.min.js';

import {Detail} from './Detail';
import {Search} from "./Search";
import {Zp} from "./Zp";
import {SearchForm} from "./SearchForm";
import {Main} from "./Main";
import {SearchMap} from './maps/SearchMap';
import {Stichwort} from "./Stichwort";
import {PreisRechner} from "./PreisRechner";
import {BookingRequest} from "./BookingRequest";

declare global {
    interface Window {
        $: JQueryStatic;
        Stichwort?: Stichwort;
        Search?: Search;
        SearchForm?: SearchForm;
        SearchMap?: SearchMap;
        Detail?: Detail;
        PreisRechner?: PreisRechner;
        BookingRequest?: BookingRequest;
        Zp: Zp;
    }
}

window.$ = $;

$(() => {
    Main.init();
});
